<style>
  .Special {
    background-color: #ff9595 !important;
  }

  .DeviceBazgasht {
    background-color: #fff895 !important;
  }

  .DeviceBazgashtAll {
    background-color: #ff9c95 !important;
  }
</style>
<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Letter Archive</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Customer Name </label>
          <input [(ngModel)]="Filter_customer" name="Filter_customer" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Letter Type</label>
          <select class="custom-select" [(ngModel)]="LetterType_Filter">
            <option value="0">All</option>
            <option value="1">Incoming Letter</option>
            <option value="2">Outgoing Letter</option>
            <option value="3">Custody Receipt</option>
            <option value="4">Custody Receipt</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Letter Subject</label>
          <select class="custom-select" [(ngModel)]="Subject_Filter">
            <option value="0">All</option>
            <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="LetterNumber_Filter" name="LetterNumber_Filter" type="number" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Instrument Name</label>
          <input [(ngModel)]="DeviceName_Filter" name="DeviceName_Filter" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-12">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Customer(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row">
        <div class="col-xl-3 mb-30">

          <div class="card card-statistics">
            <div class="card-body">
              <h5 class="card-title" *ngIf="!Procssing"> Customers ({{DataList_Customer.length}} items)</h5>
              <h5 class="card-title" *ngIf="Procssing"> Customers (Loading...)</h5>
              <!-- action group -->

              <div class="scrollbar" style="max-height: 500px;">
                <ul class="list-unstyled">
                  <li class="mb-15" *ngFor="let item of DataList_Customer
              | paginate: {
                  id: 'DataList_CustomerTable',
                  itemsPerPage: 6,
                  currentPage: page,
                  totalItems: DataList_Customer.length
                }" [ngClass]="{'Special': item.special}" style="cursor: pointer;"
                    (click)="Set_Customer_For_Letter(item)">
                    <div class="media">

                      <div class="media-body">
                        <h6 *ngIf="!item.selected" class="mt-0 "> {{item.name}} <small
                            class="float-right">{{item.code}}</small> </h6>
                        <h6 *ngIf="item.selected"
                          style="text-decoration: underline;font-style: italic;font-weight: bold;" class="mt-0 ">
                          {{item.name}} <small class="float-right">{{item.code}}</small> </h6>
                        <p>{{item.modirAmelName}}</p>
                      </div>
                    </div>
                    <div class="divider mt-15"></div>
                  </li>

                </ul>
              </div>
              <pagination-controls id="DataList_CustomerTable" nextLabel="Next" previousLabel="Previous"
                (pageChange)="page = $event"></pagination-controls>
            </div>
          </div>
        </div>
        <div class="col-xl-9 mb-30">

          <div class="card tickets">
            <div class="card-body">
              <h5 class="card-title" *ngIf="Select_Data_Customer.id>0">Customer Letters ' {{Select_Data_Customer.name}} '
              </h5>
              <h5 class="card-title" *ngIf="Select_Data_Customer.id==0">Customer Letters 'No Customer Selected'</h5>

              <br />
              <div class="scrollbar max-h-550 tickets-info" *ngIf="Select_Data_Customer.id>0">

                <div class="table-responsive">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #489b39; color: white;">
                      <tr>
                        <th>#</th>
                        <th>ID</th>
                        <th>Letter</th>
                        <th>Type</th>
                        <th>Subject </th>
                        <th>Sender</th>
                        <th>Recipient</th>
                        <th>Status</th>
                        <th>Message</th>
                        <th>Attachment</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item2 of DataList_LetterRequestCustomer
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 6,
                              currentPage: page2,
                              totalItems: (DataList_LetterRequestCustomer).length
                            }
                  " [ngClass]="{'DeviceBazgashtAll': item2.lastSection_Id===25,'DeviceBazgasht': item2.bazgasht===true}">
                        <td>{{DataList_LetterRequestCustomer.indexOf(item2)+1}}</td>
                        <td>{{item2.letterCode}}</td>
                        <td>{{item2.code}}</td>
                        <td>{{item2.letterType === 'رسید امانت' ? 'Custody Receipt' : item2.letterType === 'نامه وارده' ? 'Incoming Letter' : item2.letterType === 'نامه صادره' ? 'Outgoing Letter' : item2.letterType === 'درخواست کالیبراسیون' ? 'Calibration Request' : item2.letterType}}</td>
                        <td>{{item2.subject_name}}</td>

                        <td>{{item2.lastSender}}</td>
                        <td>{{item2.lastGiver}}</td>
                        <td>{{item2.lastSection}}</td>
                        <td>{{item2.lastOrder}}</td>
                        <td>
                          <i *ngIf="item2.peyvaset" class="fa fa-check" style="color: green;"></i>
                          <i *ngIf="!item2.peyvaset" class="fa fa-times" style="color: red;"></i>
                          <i *ngIf="item2.sms" class="fa fa-envelope" style="color: blue;"></i>
                          <i *ngIf="item2.codePeygiri" class="fa fa-money" title="{{item2.codePeygiri}}"
                            style="color: blue;"></i>
                        </td>
                        <td>{{item2.persianDate}}</td>
                        <td>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='رسید امانت'"
                            [routerLink]="['/LetterRequestCustomerPreOrder',{id:item2.id}]"><i class="fa fa-edit"></i>
                            View </a>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='نامه وارده'"
                            [routerLink]="['/LetterRequestCustomerDraftForm',{id:item2.id}]"><i class="fa fa-edit"></i>
                            View </a>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='نامه صادره'"
                            [routerLink]="['/LetterRequestCustomerForm',{id:item2.id}]"><i class="fa fa-edit"></i>
                            View </a>
                          <a target="_blank" class="btn btn-info" *ngIf="item2.letterType=='درخواست کالیبراسیون'"
                            [routerLink]="['/LetterRequestCustomerCalibration',{id:item2.id}]"><i
                              class="fa fa-edit"></i> View </a>
                        </td>

                      </tr>
                    </tbody>
                  </table>
                </div>
                <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous"
                  (pageChange)="page2 = $event"> </pagination-controls>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>